module.exports = __webpack_public_path__ + "components/panel/ski-bro/static/swiss-9514744463cc4544cbfce013beeeddcf.webp";